import AmethystGem from './amethyst-gem.webp';
import AquamarineGem from './aquamarine-gem.webp';
import DiamondGem from './diamond-gem.webp';
import EmeraldGem from './emerald-gem.webp';
import OpalGem from './opal-gem.webp';
import RubyGem from './ruby-gem.webp';
import SapphireGem from './sapphire-gem.webp';
import TopazGem from './topaz-gem.webp';
import VipGem from './vip-gem.webp';

import AmethystBadge from './amethyst-badge.webp';
import MemberBadge from './amethyst_locked-badge.webp';
import AquamarineBadge from './aquamarine-badge.webp';
import DiamondBadge from './diamond-badge.webp';
import EmeraldBadge from './emerald-badge.webp';
import OpalBadge from './opal-badge.webp';
import RubyBadge from './ruby-badge.webp';
import SapphireBadge from './sapphire-badge.webp';
import TopazBadge from './topaz-badge.webp';
import VipBadge from './vip-badge.webp';

import statusBoxPlaceholder from './status-box-placeholder.webp';
import check from './check.webp';

import statusImages from './status';

export default {
  MemberGemLegacy: undefined,
  AmethystGemLegacy: AmethystGem,
  AquamarineGemLegacy: AquamarineGem,
  DiamondGemLegacy: DiamondGem,
  EmeraldGemLegacy: EmeraldGem,
  OpalGemLegacy: OpalGem,
  RubyGemLegacy: RubyGem,
  SapphireGemLegacy: SapphireGem,
  TopazGemLegacy: TopazGem,
  VipGemLegacy: VipGem,
  MemberBadge,
  AmethystBadge,
  AquamarineBadge,
  DiamondBadge,
  EmeraldBadge,
  OpalBadge,
  RubyBadge,
  SapphireBadge,
  TopazBadge,
  VipBadge,
  check,
  statusBoxPlaceholder,

  ...statusImages,
};
